// React imports
import { useState } from "react";

// Custom components imports
import InvoiceFilterForm from "../../components/forms/invoice/InvoiceFilterForm";
import InfiniteListInvoices from "../../components/infinite_lists/InfiniteListInvoices";
import ContentWithToggle from "../../components/shared/ContentWithToggle";

// Hooks (react-router-dom") imports
import { useNavigate, useParams } from "react-router-dom";

// Custom types imports
import { fetchingModelDefaults } from "../../features/tickets/types";

// Custom queries imports
import { useTicketsInfinite } from "../../features/tickets/useTicketsInfinite";

// Hooks & actions imports
import { useAppSelector } from "../../app/hook";

// Hooks & Components (react-hook-form) imports
import { useForm, FormProvider } from "react-hook-form";

// Custom types imports
import { PaginatedModelTicket } from "../../features/tickets/types";

function Removed() {
  const [cardTypeSelected, setCardTypeSelected] = useState<number | undefined>(
    undefined
  );
  const currentUser = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const params = useParams();
  const methods = useForm<PaginatedModelTicket>({
    defaultValues: {
      ...fetchingModelDefaults,
      storeID: currentUser.user?.companyID !== -1 ? currentUser.user?.companyID : 0,
      invoiceStatus: 1,
    },
  });

  const tickets = useTicketsInfinite({
    ...methods.watch(),
    customerIdCard:
      cardTypeSelected && methods.watch("customerIdCard")
        ? `00${cardTypeSelected}${methods.watch("customerIdCard")}`
        : "",
  });

  const data = tickets.data?.pages?.flatMap((page) => page.invoices) || [];

  return (
    <div className="border-t w-full sm:max-w-[576px] mx-auto sm:mt-[40px] bg-white rounded-md">
      <ContentWithToggle
        title="Filtros"
        isToogle={true}
        defaultOpenValue={false}
      >
        <FormProvider {...methods}>
          <InvoiceFilterForm
            cardTypeSelected={cardTypeSelected}
            setCardTypeSelected={setCardTypeSelected}
            disabledReportMutation={data.length === 0}
          />
        </FormProvider>
      </ContentWithToggle>

      <ContentWithToggle
        onBackButton={() => navigate(`/${params.idUser}/escritorio`)}
        title="Cobros Eiminados"
        isToogle={false}
      >
        <InfiniteListInvoices
          tickets={tickets}
          link={(ticket) =>
            `/${ticket.idCard}/cobros/c/${ticket.invoiceID}?accessCode=${ticket.accessCode}`
          }
        />
      </ContentWithToggle>
    </div>
  );
}

export default Removed;
